<template>
  <component :is="wrapper" v-model="isShown">
    <ManageAssets @close="isShown = false" />
  </component>
</template>
<script setup lang="ts">
import StDrawer from '@st/ui/components/StDrawer/StDrawer.vue'
import ManageAssets from './ManageAssets.vue'
import StModal from '@st/ui/components/StModal/StModal.vue'

const { isMobile } = usePlatform()
const isShown = defineModel<boolean>({ default: false })

const wrapper = computed(() => (isMobile.value ? StDrawer : StModal))
</script>
